// Attach beforeinstallprompt + appinstalled listeners at app boot — before
// any Vue component mounts. Chrome dispatches beforeinstallprompt very early
// in the page lifecycle, so listeners attached only when PwaInstallButton
// mounts (after auth + dashboard layout resolves) miss the event entirely.
import { initPwaInstall } from '~/composables/usePwaInstall'

export default defineNuxtPlugin(() => {
  initPwaInstall()
})
